document.querySelectorAll('.header__menu-item').forEach((item) => {
  let timer;

  const dropdown = item.querySelector('.header__submenu');

  item.addEventListener('mouseenter', () => {
    clearTimeout(timer);
    item.classList.add('active');
    dropdown.style.opacity = '1';
    dropdown.style.visibility = 'visible';
    dropdown.style.pointerEvents = 'auto';
  });

  item.addEventListener('mouseleave', () => {
    timer = setTimeout(() => {
      item.classList.remove('active');
      dropdown.style.opacity = '0';
      dropdown.style.visibility = 'hidden';
      dropdown.style.pointerEvents = 'none';
    }, 200); // delay in milliseconds
  });

  dropdown.addEventListener('mouseenter', () => {
    clearTimeout(timer);
  });

  dropdown.addEventListener('mouseleave', () => {
    timer = setTimeout(() => {
      item.classList.remove('active');
      dropdown.style.opacity = '0';
      dropdown.style.visibility = 'hidden';
      dropdown.style.pointerEvents = 'none';
    }, 200);
  });
});
